import { usePut } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';
import { ClosureReasonModel } from '@app/models';

export function useUpdateClosureReasons() {
  const put = usePut(true, "tms");
  const updateClosureReasons = (request: ClosureReasonModel[]) =>
    put(`${referenceDataBaseUrl}/closure-reasons`, {ClosureReasons: request});

  return useMutationWithErrorHandling({
    mutationFn: async ({request }: { request: ClosureReasonModel[]}) =>
      await updateClosureReasons(request),
  });
}
